module.exports = __webpack_public_path__ + "f879c3df76d0131c4b7faa7d308d9879.pdf";